module.exports = __webpack_public_path__ + "img/hand-holding-heart.247e0bd0.svg";